function isWebRTCSupported(): boolean {
  let isWebRTCSupported = false;
  ["RTCPeerConnection", "webkitRTCPeerConnection", "mozRTCPeerConnection", "RTCIceGatherer"].forEach(item => {
    if (isWebRTCSupported) return;
    if (item in window) isWebRTCSupported = true;
  });
  return isWebRTCSupported;
}

function isGetUserMediaSupported(): boolean {
  let isGetUserMediaSupported = false;
  if (typeof navigator.getUserMedia === "function") {
    isGetUserMediaSupported = true;
  } else if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    isGetUserMediaSupported = true;
  }
  return isGetUserMediaSupported;
}

export { isWebRTCSupported, isGetUserMediaSupported };
